import { render, staticRenderFns } from "./humiture.vue?vue&type=template&id=5f2874d8&"
import script from "./humiture.vue?vue&type=script&lang=js&"
export * from "./humiture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports